import { useState, useEffect } from 'react';

/**
 * Filter state for the clients list: name search plus Canal / Gerente / Asesor selects.
 * Writes the filtered list back through `setRows`.
 */
export function useClientFilters({ setRows, clientsData }) {
    const [channel, setChannel] = useState('both');
    const [asesor, setAsesor] = useState('both');
    const [gerente, setGerente] = useState('both');
    const [suggestions, setSuggestions] = useState([]);
    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        if (!clientsData) return;
        let filteredData = clientsData;

        if (channel !== 'both') {
            filteredData = filteredData.filter((client) => client.channel === channel);
        }
        if (asesor !== 'both') {
            filteredData = filteredData.filter((client) => client.asesor === asesor);
        }
        if (gerente !== 'both') {
            filteredData = filteredData.filter((client) => client.gerente === gerente);
        }

        setRows(filteredData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [channel, asesor, gerente]);

    const gerentes = clientsData ? [...new Set(clientsData.map((client) => client.gerente))].filter(Boolean) : [];
    const asesores = clientsData ? [...new Set(clientsData.map((client) => client.asesor))].filter(Boolean) : [];

    const onSearch = (search) => {
        setSearchValue(search);
        if (!clientsData) return;
        const filteredData = clientsData.filter((client) => client.name.toLowerCase().includes(search.toLowerCase()));
        setRows(filteredData);
        setSuggestions(filteredData.map((client) => client.name));
    };

    const hasActiveFilters = channel !== 'both' || asesor !== 'both' || gerente !== 'both' || searchValue;

    const clearFilters = () => {
        setChannel('both');
        setAsesor('both');
        setGerente('both');
        setSearchValue('');
        setRows(clientsData);
    };

    return {
        channel,
        setChannel,
        asesor,
        setAsesor,
        gerente,
        setGerente,
        suggestions,
        searchValue,
        setSearchValue,
        gerentes,
        asesores,
        onSearch,
        hasActiveFilters,
        clearFilters
    };
}
